// src/helpers.ts

import axios from "axios";

export const PRODUCTION_API_URL = "https://api.tommillerservices.com/graphql";
/** Same production backend at its DigitalOcean address, used only when PRODUCTION_API_URL is unreachable. */
export const BACKUP_API_URL = "https://business-builder-backend-sy9bw.ondigitalocean.app/graphql";

export const getApiUrl = () => {
  // Check for explicit environment variable first
  const envEndpoint = process.env.REACT_APP_GRAPHQL_ENDPOINT;

  if (envEndpoint) {
    console.log("Using GraphQL endpoint from env:", envEndpoint);


    return envEndpoint;
  }

  // Production API by default, `yarn start` included, so a fresh clone works with no backend running.
  // A local backend on :4000 is opt-in: REACT_APP_ENV=development in your .env.
  const useLocalBackend = process.env.REACT_APP_ENV === "development";
  const developmentHost = typeof window !== "undefined" ? window.location.hostname : "localhost";
  const endpoint = useLocalBackend
    ? `http://${developmentHost}:4000/graphql`
    : PRODUCTION_API_URL;

  console.log("Using GraphQL endpoint:", endpoint);
  return endpoint;
};

/**
 * fetch for the GraphQL link: if the production API can't be reached at all (DNS, TLS, connection
 * refused — fetch rejects), retry once on BACKUP_API_URL. An HTTP or GraphQL error is an answer,
 * not an outage, so it never switches. Other endpoints (local, env override) are never rewritten.
 */
export const fetchWithApiFallback: typeof fetch = async (input, init) => {
  try {
    return await fetch(input, init);
  } catch (error) {
    if (String(input) !== PRODUCTION_API_URL || init?.signal?.aborted) throw error;
    console.warn(`GraphQL endpoint unreachable, retrying on backup: ${BACKUP_API_URL}`, error);
    return fetch(BACKUP_API_URL, init);
  }
};


export const getBitcoinPrice = async (): Promise<number> => {
  try {
    const response = await axios.get("https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=aud");
    return response.data.bitcoin.aud;
  } catch (error) {
    console.error("Error fetching BTC price:", error);
    return 0; // Return 0 or some default value in case of an error
  }
};

export const calculateBTCAmount = (audAmount: number, btcPrice: number): number => {
  return audAmount / btcPrice;
};

/**
 * Ensures an IPFS gateway URL has the https:// protocol.
 */
export const normalizeIpfsUrl = (url: string): string => {
  if (!url) return url;

  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  if (url.includes('files.tommillerservices.com')) {
    return `https://${url}`;
  }

  return url;
};

/**
 * Normalizes a media URL for display.
 */
export const normalizeMediaUrl = (url?: string): string => {
  if (!url) return '';
  return normalizeIpfsUrl(url);
};

